import { useQuery } from 'react-query';
import { ApiFactory } from '@/utils/apiFactory';
import { exceptionProcessorForQuery } from '@/services/infrastructure/exceptionProcessorForQuery';
import tryCatch from '@/services/infrastructure/tryCatch';

export const createKeyForListCompareJobFileObjects = (
  { spaceId, projectId, jobId },
  page,
  size,
  statuses
) => [
  `/spaces/${spaceId}/projects/${projectId}/compare-jobs/${jobId}`,
  `/spaces/${spaceId}/projects/${projectId}/compare-jobs/${jobId}/file-objects`,
  page,
  size,
  statuses
];
export const useQueryToListCompareJobFileObjects = (
  { spaceId, projectId, jobId },
  page,
  size,
  statuses,
  options = null,
  exceptionHandler = exceptionProcessorForQuery()
) =>
  useQuery(
    createKeyForListCompareJobFileObjects({ spaceId, projectId, jobId }, page, size, statuses),
    async (context) =>
      tryCatch(async () => {
        const response = await ApiFactory.cpdV3({
          method: 'get',
          url: `/compare-jobs/${jobId}/file-objects`,
          headers: {
            'cloudplex-space-id': spaceId,
            'cloudplex-project-id': projectId
          },
          params: {
            page: page,
            size: size,
            statuses: statuses
          },
          signal: context.signal
        });
        return response.data;
      }, exceptionHandler),
    { ...options }
  );
